import type { FaireProductEntity } from "../../entity_types/product";

export const p_3rhm5x538a: FaireProductEntity = {
  token: "p_3rhm5x538a",
  type: "product",
  name: "Dainty Gold Crystal Pearl Stacking Band Ring in Solid Copper",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/dc4ac413f26b41b3223ee37529a251772288c8e3b2ba42a6b3e0ee1f2d9b4c05.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/51a0f5a2aa8e61abd959c9c73c3f5b0026a6de8e2f8df0c8aa82ea097d85afe1.jpeg",
    "https://cdn.faire.com/fastly/694d91a34cc931b8d0fd75258e5e30273794b68d3fc2a9bc1ae88427929d1696.jpeg",
    "https://cdn.faire.com/fastly/966bf0fb5adad7eda80746ed9105286df0bdccdc8709c06ea9779b0ab29684a1.jpeg",
    "https://cdn.faire.com/fastly/7fc25222a5f27a8874c70797b66413cfc48f3cdef54d6a86600c6e4cdc8fe425.jpeg",
  ],
  priceDollars: 9,
  description:
    "Description & Details\n\nTimeless and elegant, these tasteful pearl rings capture a woman's appreciation for the wonders of her everyday fashion.\n\n• Material: High Quality Copper ∙ Crystal Stone ∙ Pearl\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: US size adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:43.003Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
